<template>
    <div class="informative-text" v-html="text"></div>
</template>

<script>
    export default {
        name: "Informative",
        props: {
            text: String
        }
    }
</script>

<style scoped lang="scss">
    $light-purple: #ECF0FF;
    $border-purple: #A6B9FF;

    .informative-text {
        margin-bottom: 20px;
        padding: 16px;

        font-size: 14px;
        line-height: 20px;
        border: 1px solid $border-purple;
        border-radius: 3px;
        color: $purple;
        background: $light-purple;
    }
</style>